import { Appearance, Inventory } from "game-common/models"
import { Callback } from "game-common/util"
import { Graphics } from "pixi.js"

import { disposeTextTextures } from "../../text/dispose_text"

export type PageId = "intro" | "build" | "journey" | "controls"

export interface NavButtonMeta {
    title: string
    // The one button that carries the flow forward is drawn filled and sits on the right.
    primary?: boolean
    callback: Callback<void>
}

// What a page is allowed to ask of the modal around it. Declared here (rather than importing
// CharacterBuilder) so the pages and the modal don't import each other in a cycle.
export interface BuilderHost {
    switchPage(pageId: PageId): void
    setNavButtons(buttons: NavButtonMeta[]): void
    resetNavButtons(): void
    submitCharacter(appearance: Appearance, inventory: Inventory): void
    // Redraw the screen: pages only ever change their own state, then ask for a repaint.
    refresh(): void
    close(): void
}

export abstract class BuilderPage extends Graphics {
    host: BuilderHost
    abstract readonly pageId: PageId
    // Shown in the screen's header.
    abstract readonly title: string
    // Optional line of guidance, shown at the right of the header.
    readonly hint?: string

    // Draw the page's body into `this`. The body's box is the area between the header and the nav
    // footer -- see theme.BODY_Y / BODY_H.
    abstract build(): void

    // Frame hook, only called while this page is the one on screen.
    animate(_dtMs: number) {
        //
    }

    tearDown() {
        //
    }

    // Free the per-instance Text textures of the last draw before rebuilding (they are not GC'd).
    protected wipe() {
        ;[...this.children].forEach(disposeTextTextures)
        this.removeChildren()
    }
}
